export const environment = {
  production: true,
  API_URL: 'https://back.dev.avalservi.co/api/',
  enterprise: 'avalservi',
  api_username: 'avalservi',
  api_password: 'yZW9x3QB0gGz'
};
